<script>
import newScoresAPI from "../../../services/newScores/newScoresAPI";
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification"

export default {
  props: {
    modalID: {
      type: String,
      default: null,
      required: true,
    },
  },
  data() {
    return {
      classification: {
        employees: null,
        risk_level: null,
        company_classification_id: null
      },
      company_id: this.$store.getters["company/getCompany"].id,
      loading: true,
    };
  },
  methods: {

    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    getCompany() {
      const data = { companies_id: this.company_id };
      this.loading = true;
      newScoresAPI.modalClassification(data)
        .then((response) => {
          this.loading = false;
          // Mapeo para 'company_classification_id'
          const classificationMapping = {
            1: 'UPA',
            2: 'GRUPO 1',
            3: 'GRUPO 2',
            4: 'GRUPO 3',
            5: 'SIN CLASIFICAR',
          };
          this.classification.company_classification_id = classificationMapping[response.data.company_classification_id] || 'SIN CLASIFICAR';

          // Mapeo para 'risk_level'
          const riskLevelMapping = {
            group_1: 'Nivel I',
            group_2: 'Nivel II',
            group_3: 'Nivel III',
            group_4: 'Nivel IV',
            group_5: 'Nivel V',
          };
          this.classification.risk_level = riskLevelMapping[response.data.risk_level] || 'Nivel Desconocido';

          // Asignar 'employees' directamente
          this.classification.employees = response.data.employees;
        })
        .catch((error) => {
          this.loading = false;
          console.error('Error:', error);
        });
    },

    classificationCompany() {
      const user = JSON.parse(localStorage.getItem('user'))
      const dataScores = {
        access_token: user.token,
        companies_id: this.company_id
      }
      newScoresAPI.classificationCompanie(dataScores).then((response) => {
        this.loading = false
        Swal.fire({
          title: "¡Éxito!",
          text: "¡Empresa ha sido clasificada con exito!",
          type: "success",
          icon: "success",
          confirmButtonClass: "btn btn-confirm mt-2",
        });
        window.location.reload();
      }).catch((error) => {
        console.log(error);
        Swal.fire({
          title: "¡Error!",
          text: "La empresa no ha podido ser clasificada",
          type: "warning",
          icon: "warning",
          confirmButtonClass: "btn btn-confirm mt-2",
        });
        window.location.reload();
      });
    }

  },
};
</script>

<template>
  <div>
    <button v-b-modal.classificationModal type="button" class="btn btn-primary m-l-5 ml-1" v-on:click="getCompany()">
      Clasificar Empresa
    </button>
    <b-modal id="classificationModal" title="Clasificación" title-class="font-18" dialog-class="modal-full-width"
      hide-footer>

      <div v-if="!loading">
        <div class="row">
          <div class="col-lg-4">
            <div class="text-center">
              <b-card-body>
                <b-card-text>
                  <img src="@/assets/images/workers.png" height="80px" width="80px" alt="" />
                </b-card-text>
                <span class="font-modal">
                  Número total de colaboradores activos:
                  <b>{{ classification.employees }}</b>
                </span>
              </b-card-body>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="text-center">
              <b-card-body>
                <b-card-text>
                  <img src="@/assets/images/risk-management.png" height="80px" width="80px" alt="" />
                </b-card-text>
                <span class="font-modal">
                  Nivel de riesgo:
                  <b>{{ classification.risk_level }}</b>
                </span>
              </b-card-body>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="text-center">
              <b-card-body>
                <b-card-text>
                  <img src="@/assets/images/check_sign.svg" height="80px" width="80px" alt="" />
                </b-card-text>
                <span class="font-modal">
                  Su empresa se encuentra clasificada en el grupo:
                  <b>{{ classification.company_classification_id }}</b>
                </span>
              </b-card-body>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <hr />
          </div>
        </div>

        <div class="form-group text-center m-b-0">
          <!-- Botón para cancelar -->
          <button class="btn btn-secondary mr-2" @click="$bvModal.hide('classificationModal')">
            <i class="mdi mdi-cancel m-r-1"></i> Cancelar
          </button>

          <!-- Botón para clasificar -->
          <button class="btn btn-primary" @click="classificationCompany">
            <i class="mdi mdi-check m-r-1"></i> Clasificar
          </button>
        </div>
      </div>

      <div v-else>
        <div class="text-center">
          <b-spinner variant="primary" label="Loading..."></b-spinner>
        </div>
      </div>
    </b-modal>
  </div>
</template>